import { generatePath, useRouteMatch } from "react-router-dom";

export const useBroadcastContentPath = () => {
  const { path, params } = useRouteMatch();
  const contentPath = `${path}/send-email/:broadcastId`;
  const visualBuilderPath = `${contentPath}/visual-builder`;

  const getPathToContentEditor = ({
    broadcastId,
    isVisualEmailBuilderContent,
  }: {
    broadcastId: number;
    isVisualEmailBuilderContent: boolean;
  }) => {
    if (isVisualEmailBuilderContent) {
      return generatePath(visualBuilderPath, {
        broadcastId,
        ...params,
      });
    }
    return generatePath(contentPath, {
      broadcastId,
      ...params,
    });
  };

  return {
    getPathToContentEditor,
    contentPath,
  } as const;
};
